var React = require('react');

function QuoteMarkOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_326","data-name":"Path 326","d":"M16.523-85.43,10.02-59.3H1.406L9.668-85.43Zm-17.812,0L-7.617-59.3h-8.789L-8.2-85.43Z","transform":"translate(16.406 85.43)","fill":"#ffbb5a"}));
}

QuoteMarkOpen.defaultProps = {"width":"32.93","height":"26.133","viewBox":"0 0 32.93 26.133"};

module.exports = QuoteMarkOpen;

QuoteMarkOpen.default = QuoteMarkOpen;
